var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("div", { staticClass: "card" }, [
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            { staticClass: "refresh_btn" },
            [
              _c("LoadingButton", {
                attrs: {
                  title: "Обновить",
                  className: "btn btn-outline-info btn-xs",
                  onClick: () => _vm.$refs?.watchSuppliers?.getCodes(),
                  loading: _vm.loading,
                  color: _vm.$constants.PRIMARY_COLOR,
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("table", { staticClass: "table mt-0 table-sm" }, [
            _vm._m(0),
            _vm._v(" "),
            _c("tbody", [
              _c("tr", [
                _c("td", [
                  _c("strong", [_vm._v(_vm._s(_vm.record?.drug?.title))]),
                ]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.record.call))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.record.price))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(_vm.record.stores))]),
              ]),
            ]),
          ]),
          _vm._v(" "),
          _c(
            "div",
            [
              _c("WatchUtekaTask", {
                ref: "watchSuppliers",
                attrs: { drug: _vm.record.drug },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "flex justify-content-between" }, [
        _c(
          "div",
          { staticClass: "flex-grow-1" },
          [
            !_vm.addRecordComment
              ? _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.addRecordComment = true
                      },
                    },
                  },
                  [_vm._v("Добавить\n        комментарий к записи\n      ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.showHideReasonBlock
              ? [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.hideReasonText,
                        expression: "hideReasonText",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      type: "text",
                      rows: "3",
                      placeholder: "Комментарий к записи скрытия",
                    },
                    domProps: { value: _vm.hideReasonText },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) return
                        _vm.hideReasonText = $event.target.value
                      },
                    },
                  }),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "flex flex_gap_10" },
          [
            _c("LoadingButton", {
              attrs: {
                title: "Сохранить и скрыть",
                type: "button",
                loading: _vm.saveLoading,
                color: _vm.$constants.SUCCESS_COLOR,
                onClick: () => _vm.saveTasks(true),
                className: "btn btn-outline-success",
              },
            }),
            _vm._v(" "),
            _c("LoadingButton", {
              attrs: {
                title: "Сохранить условия",
                type: "button",
                loading: _vm.saveLoading,
                color: _vm.$constants.SUCCESS_COLOR,
                onClick: () => _vm.saveTasks(),
                className: "btn btn-success",
              },
            }),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.addRecordComment
        ? _c("div", { staticClass: "card mt-2" }, [
            _vm._m(1),
            _vm._v(" "),
            _c("div", { staticClass: "card-body" }, [
              _c("textarea", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.recordDetails.comment.value,
                    expression: "recordDetails.comment.value",
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  placeholder: "Комментарий к препарату 003sm",
                  rows: "2",
                },
                domProps: { value: _vm.recordDetails.comment.value },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(
                      _vm.recordDetails.comment,
                      "value",
                      $event.target.value
                    )
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "text-right mt-1" },
                [
                  _c("LoadingButton", {
                    attrs: {
                      title: "Сохранить комментарий",
                      type: "button",
                      loading: _vm.saveLoading,
                      color: _vm.$constants.SUCCESS_COLOR,
                      onClick: () => _vm.updateRecordDetail("comment"),
                      className: "btn btn-outline-success",
                    },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "card mt-2" }, [
        _vm._m(2),
        _vm._v(" "),
        _c("div", { staticClass: "card-body" }, [
          _c(
            "div",
            { staticClass: "flex" },
            [
              _vm._l(_vm.taskOptions, function (t, alias, i) {
                return _c("div", { key: i, staticClass: "mr-1" }, [
                  _c(
                    "button",
                    {
                      class: {
                        "btn btn-outline-primary": true,
                        active: _vm.selectedTasks[alias],
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          _vm.selectedTasks[alias] = !_vm.selectedTasks[alias]
                        },
                      },
                    },
                    [
                      _c("input", {
                        attrs: { type: "checkbox", autocomplete: "off" },
                      }),
                      _vm._v(
                        "\n            " + _vm._s(t?.title) + "\n          "
                      ),
                    ]
                  ),
                ])
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass:
                    "flex flex-grow-1 justify-content-end flex_gap_10",
                },
                [
                  _vm.task?.type_id !== 4
                    ? _c(
                        "button",
                        {
                          staticClass: "btn btn-default",
                          attrs: { type: "button" },
                          on: {
                            click: function ($event) {
                              return _vm.actionByModal(
                                "AddStatRecordToModeration"
                              )
                            },
                          },
                        },
                        [_vm._v("на\n            модерацию\n          ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.task?.type_id !== -1
                    ? [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.actionByModal("AddStatToBlackList")
                              },
                            },
                          },
                          [_vm._v("черный список\n            ")]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-default",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.actionByModal("NoSupplierStatsTask")
                              },
                            },
                          },
                          [_vm._v("нет поставки\n            ")]
                        ),
                      ]
                    : _vm._e(),
                ],
                2
              ),
            ],
            2
          ),
        ]),
      ]),
      _vm._v(" "),
      _vm._l(_vm.selectedTasks, function (a, alias) {
        return a && _vm.taskOptions[alias]
          ? _c("div", { staticClass: "mt-1 border p-1 card shadow-sm" }, [
              _c("div", { staticClass: "card-header bg-info" }, [
                _c("h5", [
                  _vm._v("Задача "),
                  _c("strong", [_vm._v(_vm._s(_vm.taskOptions[alias]?.title))]),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "card-body p-2" },
                [
                  alias === "createNewDrug"
                    ? [
                        _c("NewDrugTask", {
                          ref: "createNewDrug",
                          refInFor: true,
                          attrs: { taskData: _vm.newTasksData[alias] },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  alias === "pairDrug"
                    ? [
                        _c("PairDrug", {
                          ref: "pairDrug",
                          refInFor: true,
                          attrs: {
                            drug: _vm.record.drug,
                            taskData: _vm.newTasksData[alias],
                            pairedDrugs: _vm.record.drug.related_drugs,
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  alias === "blackList"
                    ? [
                        _c("BlackListMSStat", {
                          ref: "blackList",
                          refInFor: true,
                          attrs: {
                            getConditionTasks: () => _vm.getConditionTasks(),
                            taskData: _vm.newTasksData[alias],
                            record003Id: _vm.record.drug.id,
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  alias === "pairCodes"
                    ? [
                        _c("PairCodes", {
                          attrs: { record003Id: _vm.record.drug.id },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  alias === "storeCall"
                    ? [
                        _c("ManufacturerDrugInfoTask", {
                          attrs: {
                            record: _vm.record,
                            task:
                              (_vm.record.drug.tasks ?? []).find(
                                (t) => t.type_id === 22
                              ) ?? {},
                          },
                        }),
                      ]
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.commentsIn.includes(alias)
                    ? _c("div", { staticClass: "form-group mt-1 p-1" }, [
                        _c("label", [_vm._v("Комментарий")]),
                        _vm._v(" "),
                        _c("textarea", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.newTasksData[alias].comment,
                              expression: "newTasksData[alias].comment",
                            },
                          ],
                          staticClass: "form-control",
                          attrs: { rows: "2" },
                          domProps: { value: _vm.newTasksData[alias].comment },
                          on: {
                            input: function ($event) {
                              if ($event.target.composing) return
                              _vm.$set(
                                _vm.newTasksData[alias],
                                "comment",
                                $event.target.value
                              )
                            },
                          },
                        }),
                      ])
                    : _vm._e(),
                ],
                2
              ),
            ])
          : _vm._e()
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Препарат")]),
        _vm._v(" "),
        _c("th", [_vm._v("Спрос")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ср.цена")]),
        _vm._v(" "),
        _c("th", [_vm._v("Наличие")]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Комментарий к записи")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h6", [_vm._v("Действия по препарату")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }